import type { CSSProperties } from 'react'
import { GRADIENT, SHADOW_BRAND } from './format'

export type AccountTab = 'overview' | 'events' | 'following' | 'notifications' | 'settings'

const TABS: { key: AccountTab; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'events', label: 'My events' },
  { key: 'following', label: 'Following' },
  { key: 'notifications', label: 'Notifications' },
  { key: 'settings', label: 'Settings' },
]

interface AccountTabsProps {
  active: AccountTab
  onChange: (tab: AccountTab) => void
  unreadCount?: number
}

export function AccountTabs({ active, onChange, unreadCount = 0 }: AccountTabsProps) {
  return (
    <div role="tablist" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      {TABS.map(({ key, label }) => {
        const isActive = active === key
        const base: CSSProperties = {
          height: 38,
          padding: '0 18px',
          borderRadius: 999,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          fontSize: 14,
          fontFamily: 'inherit',
          cursor: 'pointer',
          fontWeight: isActive ? 600 : 500,
          color: isActive ? '#fff' : 'var(--ink-2)',
          background: isActive ? GRADIENT : 'transparent',
          border: 0,
          whiteSpace: 'nowrap',
          boxShadow: isActive ? SHADOW_BRAND : 'none',
        }
        return (
          <button
            key={key}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(key)}
            style={base}
          >
            {label}
            {key === 'notifications' && unreadCount > 0 && (
              <span
                style={{
                  minWidth: 18,
                  height: 18,
                  padding: '0 5px',
                  borderRadius: 999,
                  fontSize: 10.5,
                  fontWeight: 700,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: isActive ? 'rgba(255,255,255,0.28)' : GRADIENT,
                  color: '#fff',
                }}
              >
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
